export default __webpack_public_path__ + "static/img1h-8d9baf4807f9da6045a1252f47a95b97.jpg";